import { Icon } from './Brand.jsx';
import { usePins } from '../pins/PinsContext.jsx';

export default function PinButton({ siteName, showLabel = false }) {
  const { status, sites, limit, pendingSite, isPinned, toggle } = usePins();
  const pinned = isPinned(siteName);
  const pending = pendingSite === siteName;
  const atLimit = !pinned && sites.length >= limit;
  const disabled = status !== 'ready' || Boolean(pendingSite) || atLimit;
  const action = pinned ? 'Unpin' : 'Pin';
  const label = atLimit ? `Pin limit reached for ${siteName}` : `${action} ${siteName}`;

  return (
    <button
      type="button"
      className={`pin-button${pinned ? ' is-pinned' : ''}${showLabel ? ' pin-button--labelled' : ''}`}
      aria-label={label}
      aria-pressed={pinned}
      title={label}
      disabled={disabled}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        toggle(siteName);
      }}
    >
      <Icon name="pin" size={16} />
      {showLabel ? <span>{pending ? 'Saving…' : pinned ? 'Pinned' : 'Pin site'}</span> : null}
      {!showLabel && pending ? <span className="visually-hidden">Saving</span> : null}
    </button>
  );
}
